<template>
  <b-container fluid class="mb-5 mt-5">
    <b-row class="text-center" style="height: 250px">
      <b-col cols="1" md="2" lg="4"></b-col>
      <b-col cols="10" md="8" lg="4" class="other">
        <br><br>
        <div>There was an error in your submission. <br><br>Please contact the representative identified on your arrival information.</div>
      </b-col>
      <b-col cols="1" md="2" lg="4"></b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Error',
  data() {
    return {
      resid: null
    }
  },
}
</script>
<style>
body {
  background-color: #C4E1F0 !important;
}
.other {
    height: 100vh; 
    display: flex;
    justify-content: center;
    align-items: center;  
    color:#416279; 
    font-size:14pt;
}
</style>